import React, { useState, useEffect } from "react";
import StepButtons from "../components/StepButtons";
import { postToServer } from "../apis";
import "jquery-mask-plugin/dist/jquery.mask.min.js";
import $ from "jquery";
import Select from "react-select";
import GoToReviewPageButton from "../components/GoToReviewPageButton";
import CustomDatePicker from "../components/CustomDatePicker";

const DriverInfo = ({
  data,
  setData,
  backPage,
  nextPage,
  credentials,
  setCredentials,
  signedImage,
  companies,
  selectedCompany,
  setSelectedCompany,
  isDone,
  lastPage,
  pageNo,
}) => {
  // Load data from local storage when component mounts
 useEffect(() => {
  const storedData = localStorage.getItem('driverInfoData');
  if (storedData) {
    setData(JSON.parse(storedData));
  }
}, []);

/* useEffect(() => {
  localStorage.setItem('driverInfoData', JSON.stringify(data));
}, [data]);
console.log("data",data) */
//////////////companylocalstorage
 // Load selected company from local storage when the component mounts
useEffect(() => {
  const storedSelectedCompany = localStorage.getItem("selectedCompany");

  if (storedSelectedCompany) {
    setSelectedCompany(JSON.parse(storedSelectedCompany));
  }
}, [setSelectedCompany]);

// If companies data is available, and selectedCompany is not set, set the default company
useEffect(() => {
  if (companies.length > 0 && !selectedCompany) {
    setSelectedCompany([companies[0]]);
  }
}, [companies, selectedCompany, setSelectedCompany]);

// Save selected company to local storage whenever selectedCompany changes
/* useEffect(() => {
  localStorage.setItem("selectedCompany", JSON.stringify(selectedCompany));
}, [selectedCompany]);
 */

///////////////////////////////////

const eventHandler = (e) => {
  setData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
};

  

  const goNext = async (goLast) => {
    const form = $("#data-form");
    form.validate();
  
    if (data.tk_company_uid !== '') {
      document.getElementById('tk_company_uid-error').style.display = 'none';
      document.querySelector(".css-1s2u09g-control").classList.remove('req-error');
    } else {
      document.getElementById('tk_company_uid-error').removeAttribute('style');
      document.querySelector(".css-1s2u09g-control").classList.add('req-error');
    }
  
    if (form.valid()) {
      if (data.tk_company_uid !== '') {
        if (pageNo === 14) {
          data.driver_type = '1';
        }
        localStorage.setItem("selectedCompany", JSON.stringify(selectedCompany));
   localStorage.setItem('driverInfoData', JSON.stringify(data));
        // Check if credentials are already in local storage
        const storedDuid = localStorage.getItem('duid');
        const storedParentId = localStorage.getItem('parent_id');
  
        if (storedDuid && storedParentId) {
          // Use credentials from local storage
          const reqObj = {
            ...data,
            duid: storedDuid,
            parent_id: storedParentId,
            signature_input: signedImage
          };
  
          const result = await postToServer("/driverInfo", reqObj);
         
            
          if (result.status) {
            goLast ? lastPage() : nextPage();
          }
        } else {
          // Credentials are not in local storage, check if there are credentials in the state
          const reqObj = credentials.duid && credentials.parent_id
            ? { ...data, ...credentials, signature_input: signedImage }
            : { ...data, signature_input: signedImage };
  
          const result = await postToServer("/driverInfo", reqObj);
  
          if (result.status) {
            if (!credentials.duid && !credentials.parent_id) {
              // Store credentials in local storage
              localStorage.setItem('duid', result.data.duid);
              localStorage.setItem('parent_id', result.data.parent_id);
            }
  
            goLast ? lastPage() : nextPage();
          }
          
        }
      }
    }
  };

  useEffect(() => {
    const storedBasicInfo = localStorage.getItem('basicinfo');

    if (storedBasicInfo) {
      // Parse the stored string back into an object
      const parsedBasicInfo = JSON.parse(storedBasicInfo);

      // Update the component state with the retrieved data
      setData((prevData) => ({ ...prevData, ...parsedBasicInfo }));
    }
  }, []);

  const handleSearchSelect = (selectedObj) => {
    setData({ ...data, tk_company_uid: selectedObj.map(val => val.value), tk_company_name: selectedObj.map(val => val.label) });
    setSelectedCompany(selectedObj);
  };

  const filterOption = (option, inputValue) =>
    (option.label.toLowerCase().match(inputValue.toLowerCase()) || []).length >
    0;

   
    $(".usPhn").mask("000-000-0000");
    $(".ssn").mask("000-00-0000");
  
  
  /*   useEffect(() => {
      // If companies data is available, and selectedCompany is not set, set the default company
      if (companies.length > 0 && !selectedCompany) {
        setSelectedCompany([companies[0]]);
      }
    }, [companies, selectedCompany, setSelectedCompany]); */
    /////
  return (
    <>
      <div className="general-content driver-info">
        <div className="row d-flex">
          <div className="col-md-12">
            <div className="driver-form-container">
              <div className="container">
                <form id="data-form" autoComplete="off">
                  <div className="form-wrap">
                    <div className="row">
                      <div className="col-md-4 company-name">
                        <div className="form-group">
                          <label>Choose Company Name</label>
                          
                          <Select
                            options={companies}
                            value={selectedCompany}
                            onChange={handleSearchSelect}
                            
                            isMulti
                            filterOption={filterOption}
                            id="tk_company_uid"
                          />
                          <label style={{display: 'none'}} id="tk_company_uid-error" className="label-error">This field is required.</label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>First Name / Middle Name</label>
                          <input
                            className="form-control"
                            type="text"
                            name="d_first_name"
                            id="d_first_name"
                            value={data.d_first_name}
                            onChange={eventHandler}
                            maxLength="80"
                            required
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-4">
                        <div className="form-group">
                          <label>Middle Name</label>
                          <input
                            className="form-control"
                            type="text"
                            name="d_middle_name"
                            value={data.d_middle_name}
                            onChange={eventHandler}
                            maxLength="80"
                          />
                        </div>
                      </div> */}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Last Name</label>
                          <input
                            className="form-control"
                            type="text"
                            name="d_last_name"
                            id="d_last_name"
                            value={data.d_last_name}
                            onChange={eventHandler}
                            maxLength="50"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Date of Birth</label>
                          {/* <input
                            className="form-control jqdate"
                            type="text"
                            name="d_date_of_birth"
                            id="d_date_of_birth"
                            value={data.d_date_of_birth}
                            onChange={eventHandler}
                            placeholder="MM/DD/YYYY"
                            required
                          /> */}
                          {/* <CusDatePicker
                            name="d_date_of_birth"
                            data={data}
                            setData={setData}
                            required={true}
                          /> */}
                          <CustomDatePicker
                            name="d_date_of_birth"
                            data={data}
                            setData={setData}
                            required={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>E-mail</label>
                          <input
                            className="form-control"
                            type="email"
                            name="d_email"
                            value={data.d_email}
                            onChange={eventHandler}
                            maxLength="80"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Phone Number</label>
                          <input
                            className="form-control usPhn"
                            type="text"
                            name="d_phone_number"
                            value={data.d_phone_number}
                            onChange={eventHandler}
                            minLength="10"
                            maxLength="10"
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                       {pageNo === 14 ? ( 
					  <>  <input
                            className="form-control ssn"
                            type="hidden"
                            name="d_social_s_no"
                            value='0'
                            
                          />
                          <input
                            type="hidden"
                            name="lastinsertmvrdataid"
                            id="lastinsertmvrdataid"
                            value={data.lastinsertmvrdataid}
                            onChange={eventHandler}
                            required
                          /></> 
					   
					   ) : (<> 
					   <div className="form-group"> 
                          <label>Social Security Number</label>
                          <input
                            className="form-control ssn"
                            type="text"
                            name="d_social_s_no"
                            value={data.d_social_s_no}
                            onChange={eventHandler}
                            maxLength="10"
                            required
                          />
                          <input
                            type="hidden"
                            name="lastinsertmvrdataid"
                            id="lastinsertmvrdataid"
                            value={data.lastinsertmvrdataid}
                            onChange={eventHandler}
                            required
                          />
                        </div>
						</>)}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <StepButtons goBack={backPage} goNext={goNext} nextAllowed={true} />
      <GoToReviewPageButton update={goNext} isDone={isDone} />
    </>
  );
};

export default DriverInfo;
